import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { CallBlurType } from '@gem/call/constants';
import { IcBlockIcon, IcProfileIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { getMascotImageSrc } from '@gem/utils';

import { BackgroundItem } from '../BackgroundItem/BackgroundItem';
import { BackgroundPanelHeader } from '../BackgroundPanelHeader/BackgroundPanelHeader';
import { BackgroundPanelVideo } from '../BackgroundPanelVideo/BackgroundPanelVideo';
import { useBackgroundPanelPresenter } from './BackgroundPanel.presenter';
import styles from './BackgroundPanel.styles.m.css';

interface IBackgroundPanelProps {
  isCompact?: boolean;
}
export const BackgroundPanel: FC<IBackgroundPanelProps> = observer((props) => {
  const { presenter, videoRef } = useBackgroundPanelPresenter();
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <BackgroundPanelHeader
        onClose={presenter.onClose}
        isCompact={props.isCompact}
      />
      <div className={styles.content}>
        {presenter.hasVideo && <BackgroundPanelVideo videoRef={videoRef} />}
        <div className={styles.blurBlock}>
          <h3 className={styles.blurTitle}>{t('call_no_effects_and_blur')}</h3>
          <div className={styles.blurList}>
            <BackgroundItem
              icon={IcBlockIcon}
              isActive={presenter.activeBlurType === CallBlurType.None}
              onClick={presenter.onBlurClick}
              blurType={CallBlurType.None}
            />
            <BackgroundItem
              icon={IcProfileIcon}
              isActive={presenter.activeBlurType === CallBlurType.Small}
              background={getMascotImageSrc('blur-image-1.png')}
              onClick={presenter.onBlurClick}
              blurType={CallBlurType.Small}
            />
            <BackgroundItem
              icon={IcProfileIcon}
              isActive={presenter.activeBlurType === CallBlurType.Large}
              background={getMascotImageSrc('blur-image-2.png')}
              onClick={presenter.onBlurClick}
              blurType={CallBlurType.Large}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
